import { Component, inject, input, model } from '@angular/core';

import { ModalService } from '../../../services';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-ok-modal',
  templateUrl: './ok-modal.component.html',
  styleUrl: './ok-modal.component.scss',
  imports: [SummaryTopComponent],
})
export class OkModalComponent {
  private readonly modalService = inject(ModalService);

  public readonly header = model<string>();
  public readonly message = model<string>();
  public readonly okLabel = input($localize`Ok`);

  onOk() {
    this.modalService.close();
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
